var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked3D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66927 3.33203C4.8276 3.33203 3.33594 4.8237 3.33594 6.66536V26.6654C3.33594 28.507 4.8276 29.9987 6.66927 29.9987H26.6693C28.5109 29.9987 30.0026 28.507 30.0026 26.6654V6.66536C30.0026 4.8237 28.5109 3.33203 26.6693 3.33203H6.66927ZM22.6458 9.9987L25.0026 12.3555L15.0026 22.3555L8.33594 15.6888L10.6927 13.332L15.0026 17.6419L22.6458 9.9987ZM33.3359 9.9987V33.332H10.0026V36.6654H33.3359C35.1776 36.6654 36.6693 35.1737 36.6693 33.332V9.9987H33.3359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked3D);
export default __webpack_public_path__ + "static/media/checked-3D.07425ba98a3571a902e8f1716e5df49a.svg";
export { ForwardRef as ReactComponent };